<template>
    <div class="my-6 flex max-w-prose flex-col gap-6">
        <client-only>
            <template
                v-for="(part, idx) in textParts"
                :key="idx"
            >
                <TextyDivPart
                    :html="part.html"
                    :style-class="part.styleClass"
                    :tema
                    :is-last-div="idx === textParts.length - 1"
                />
            </template>
        </client-only>
    </div>
</template>

<script lang="ts" setup>
const { text, tema } = defineProps<{
    tema: TemaItem
    text: string
}>()

const REGEX_DIV_STYLES =
    '(<div class="uap\\d{2}c?">|<ul>|<ol>)(.*?)(</div>|</ul>|</ol>)'
const REGEX_STYLE_CODE = "uap\\d{2}c?|<ul>|<ol>"

type TextPart = {
    html: string
    styleClass: string
}

const textParts = computed<TextPart[]>(() => {
    const correctedText = correctText(text)
    const parts = splitTextToParts(correctedText)
    return processParts(parts).filter(part => part !== undefined)
})

function splitTextToParts(text: string) {
    // const regex = new RegExp(`${REGEX_FOOTNOTE}|${REGEX_STYLES}`, "g")
    const regex = new RegExp(`${REGEX_DIV_STYLES}`, "g")
    const matches = text.match(regex)

    // Split the text manually
    const parts = []
    let lastIndex = 0

    if (matches) {
        matches.forEach(match => {
            const index = text.indexOf(match, lastIndex)
            if (index > lastIndex) {
                parts.push(text.substring(lastIndex, index))
            }
            parts.push(match)
            lastIndex = index + match.length
        })
    }

    // Add any remaining text after the last match
    if (lastIndex < text.length) {
        parts.push(text.substring(lastIndex))
    }
    return parts
}

function processParts(parts: string[]): Array<TextPart | undefined> {
    return parts.map(part => {
        const styleClass = part.match(new RegExp(REGEX_STYLE_CODE))?.[0]
        const groups = new RegExp(REGEX_DIV_STYLES)
        if (!styleClass) return
        return {
            html: part.replace(groups, "$2"),
            styleClass:
                styleClass === "<ul>"
                    ? "uap13"
                    : styleClass === "<ol>"
                      ? "uap12"
                      : styleClass === "<li>"
                        ? "uap99"
                        : styleClass,
        }
    })
}

function correctText(text: string) {
    return text
        .replace(/🡪 Obr. /g, "🡪&nbsp;Obr.&nbsp;")
        .replace(/<sup><sup>/g, "<sup>")
        .replace(/<\/sup><\/sup>/g, "</sup>")
        .replace(/a href/g, 'a target="_blank" href')
}
</script>

<style scoped lang="scss">
:deep(.uap13),
:deep(.uap12) {
    @apply pl-8 text-lg;

    li {
        @apply relative mb-1 font-prolight last:mb-0;
    }
}
:deep(.uap13 li) {
    &::before {
        @apply absolute -left-7 top-px block pr-2 font-probold line-through;
        content: "\00a0\00a0\00a0\00a0\00a0";
    }
}

/* :deep(.uap06) {
    @apply text-anotace;
}
:deep(.uap09) {
    @apply text-odstavec;
}
:deep(.uap20) {
    @apply text-zdroj-figury;
} */
</style>
